import 'react';
import '../uniqueId.js';
import '../types/props.js';
import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import '../Card/styled.js';
import '../Card/CardCard.js';
import '../Card/CardHeader.js';
import '../Card/CardContent.js';
import '../Card/CardTitle.js';
import '../Card/CardFooter.js';
import '../Callout/styled.js';
import '../Callout/CalloutClose.js';
import '../chunk-54397449.js';
import _Callout from '../Callout/index.js';
import 'reakit/Overlay';
import '../Overlay/OverlayContainer.js';
import '../Overlay/styled.js';
import '../Overlay/OverlayHide.js';
import '../Overlay/OverlayShow.js';
import '../Overlay/OverlayToggle.js';
import '../chunk-7b491460.js';
import Overlay from '../Overlay/index.js';
var Callout = styled(_Callout).withConfig({
  displayName: "styled__Callout",
  componentId: "sc-1cy4n2f-0"
})(["max-width:500px;@media screen and (max-width:calc(500px + ", "em)){width:100%;&{", ";}}&{", ";}"], space(5), theme('fannypack.CalloutOverlay.Callout.mobile'), theme('fannypack.CalloutOverlay.Callout.base'));
var CalloutOverlay = styled(Overlay).withConfig({
  displayName: "styled__CalloutOverlay",
  componentId: "sc-1cy4n2f-1"
})(["", ";"], theme('fannypack.CalloutOverlay.base'));
export default CalloutOverlay;
export { Callout };